<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    var width = $(window).width();
    $(".login .text").css("font-size", width * 0.025 + "px");
  }
}
</script>

<style>
    #app {
      font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
      font-size: 16px;
      overflow: hidden;
    }
    body,
    p{
      padding: 0;
      margin: 0;
    }
    a{
      color: inherit;
      text-decoration: none;
    }
    input, textarea, button, select {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        outline: none;
        /* -webkit-appearance: none; */
        border-radius: 0;
        box-sizing: border-box;
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .el-table .el-table__cell{
      padding: 11px 0;
    }
    .center{
      /* width: 1200px; */
      width: 100%;
      margin: 0 auto;
      padding: 0 20px;
    }
    .flex{
      display: flex;
      align-items: center;
    }
    .nav{
      background: #fff;
      /* padding: 15px 0; */
      justify-content: space-between;
      height: 4vh;
      /* box-shadow: 0.557px 3.961px 5px 0px rgba(44, 34, 19, 0.11); */
      /* --space: 18px; */
    --bg: #fff9d1;
    --trans: #ffee7b;
    --light: #fd0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    gap: var(--space);
    font-size: 14px;
    color: #333;
    padding: 0 var(--space);
    background: linear-gradient(135deg, var(--bg) 40%, var(--light) 48%, var(--light) 52%, var(--trans) 59%, var(--bg) 70%, var(--bg) 82%);
    background: #5bcee1;
    }
    .nav .center{
      gap: 18px;
      justify-content: space-between;
    }
    .nav-text{
      flex: 1;
      visibility: hidden;
    }
    .logo-title{
      width: 100%;
      overflow: hidden;
      line-height: 40px;
      height: 40px;
    }
    .logo-title .el-carousel--vertical{
      height: 100%;
    }
    .logo-title h3{
      margin: 0;
      padding: 0;
      color: #fb650a;
      font-size: 15px;
    }
    .logo-title .el-carousel__indicators--vertical{
      display: none;
    }
    .nav-reg{
      gap: 18px;
    }
    .nav-reg .yidong{
      cursor: pointer;
    }
    .applet{
      width: 240px;
      background: #fff;
    }
    .applet .qrCode{
      width: 124px;
      margin: 0 auto;
    }
    .applet img{
      width: 100%;
      max-width: 100%;
    }
    .applet .text{
      gap: 4px;
      justify-content: center;
      margin: 10px 0 0;
    }
    .applet .text img{
      width: 20px;
    }
    .nav-reg .com{
      border-radius: 12px;
      background: #fff;
      line-height: 24px;
    }
    .nav-reg .com .el-dropdown-link {
      cursor: pointer;
      padding: 0 24px;
    }
    .nav-reg .com .el-icon-arrow-down {
      font-size: 12px;
    }
    .nav-reg-text{
      margin-left: 15px;
    }
    .nav-reg-text:hover{
      color: blue;
      text-decoration: underline;
    }
    .nav-text img{
      width: 22px;
    }
    .dd{
      padding: 12px 0 52px 12px;
      justify-content: space-between;
      background: #ffdd00;
      background: #5bcee1;
    }
    .dd .lefts img{
      margin-right: 30px;
      height: 85px;
    }
    .dd .rights{
      position: relative;
      background: #fff;
      padding: 10px 0 10px 20px;
      border-radius: 20px 0 0 20px;
      font-size: 14px;
      align-items: flex-start;
      cursor: pointer;
    }
    .dd .rights ul{
      margin: 0;
      padding: 0;
    }
    .dd .rights ul div{
      display: flex;
    }
    .dd .rights ul li{
      width: 80px;
      flex-direction: column;
      border-right: 1px solid #ffdd00;
      font-size: 12px;
      color: #555;
      line-height: 16px;
    }
    .dd .top{
      margin-bottom: 5px;
    }
    .dd li p{
      font-size: 18px;
      font-weight: bold;
    }
    .dd .top li p{
      color: #eb3935;
    }
    .dd .top li:last-child{
      border-right: 0;
    }
    .dd .chakan{
      margin: 4px 14px 0 0;
      font-size: 12px;
      color: #666;
      cursor: pointer;
    }
    .dd .bo li p{
      font-weight: bold;
    }
    .dd .bo li:last-child{
      border-right: 0;
    }
    .user-text{
      color: inherit!important;
      text-decoration: none!important;
    }
    .logo-title p{
      font-size: 15px;
    color: #fb650a;
    font-weight: bold;
    }
    .logo-title span{
      font-size: 12px;
      line-height: 16px;
    }
    .main{
      background: #f7f7f7;
      overflow: hidden;
    }
    li{
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .mains{
      height: calc(100vh - 170px);
      padding-top: 5px;
      align-items: flex-start;
      width: calc(100% - 30px);
      margin: 0 auto;
      margin-top: -34px;
    }
    .left{
      width: 285px;
      /* margin-right: 18px; */
      background: #fff;
    }
    .left ul li i{
      color: #606266;
    }
    .right{
      width: calc(100% - 285px - 40px);
      height: calc(92vh - 80px);
      padding: 20px;
      /* box-sizing: border-box; */
    }
    .right .top{
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .right .top .btn{
      margin-right: 15px;
    }
    .right .top .el-form-item{
      margin-bottom: 0;
    }
    .right .top .el-form-item:last-child{
      margin-right: 0;
    }
    .right .title{
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }
    .right .bot{
      padding: 30px;
      background: #fff;
      height: calc(100% - 40px);
      box-sizing: border-box;
    }
    .right .hetong{
      overflow-y: scroll;
    }
    .right .hetong-title{
      text-align: right;
      vertical-align: middle;
      font-size: 24px;
      color: #606266;
      padding: 0 12px 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 141px;
      margin-bottom: 22px;
    }
    .right .hetong::-webkit-scrollbar-track,
    .xiangmu .el-table__body-wrapper::-webkit-scrollbar-track{
      /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
      /* border-radius: 5px; */
      background-color: #fff;
    }
    .right .hetong::-webkit-scrollbar,
    .xiangmu .el-table__body-wrapper::-webkit-scrollbar{
      width: 5px;
      height: 5px;
      background-color: #f5f5f5;
    }
    .right .hetong::-webkit-scrollbar-thumb,
    .xiangmu .el-table__body-wrapper::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      background-color: #409eff;
    }
    .page{
      margin-top: 22px;
      justify-content: space-between;
    }
    .page .el-pagination__sizes{
      display: none!important;
    }
    .page .sk .li{
      margin-left: 30px;
      font-size: 15px;
      font-weight: bold;
    }
    .page .sk .li em{
      font-style: normal;
      color: #409EFF;
    }
    .el-table td, .el-table th{
      padding: 10px 0;
    }
    .contract{
      width: 70%;
      margin: 0 auto;
    }
    .yaoqiu{
      margin-bottom: 12px;
    }
    .project .el-radio{
      margin-right: 5px;
    }
    .project .el-radio:nth-child(1){
      margin-left: 5px;
    }
    .xgtDialog .el-form-item{
      margin-bottom: 0;
    }
    .xgtDialog .el-form-item__content{
      display: flex;
    }
    @media screen and (max-width: 1680px){
      .left{
        width: 300px;
      }
      .right{
        width: calc(100% - 360px);
      }
      .chuzhi label:nth-child(1){
        margin-bottom: 5px;
      }
    }
    @media screen and (max-width: 1500px){
      .page .sk .li{
        font-size: 13px;
        margin-left: 10px;
      }
    }
    @media screen and (max-width: 1400px){
      .el-table .el-table__cell{
        padding: 6px 0;
      }
      .page{
        margin-top: 12px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue